import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    justify-content: space-around;
    display: flex;
    flex-wrap: wrap;
`

export const Logo = styled.div`
    display: inline-block;
    height: ${ props => props.vSize ? props.vSize : "4rem"};
    overflow: hidden;
    box-sizing: border-box; 
    margin: 10px;
    position: relative;

    img {
        height: 100%;
        object-fit: contain;
    }

    a {
        height: 100%;
    }
`